import { render } from "./ImageDetailPreview.vue?vue&type=template&id=160b5c0d"
import script from "./ImageDetailPreview.vue?vue&type=script&lang=js"
export * from "./ImageDetailPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__